var map = {
	"./AI.svg": "QZEh",
	"./agreement.svg": "2/6F",
	"./case.svg": "CcGu",
	"./collapse.svg": "cD3V",
	"./company.svg": "BcmM",
	"./cost.svg": "2a9B",
	"./custom.svg": "0LDi",
	"./detail-tm1.svg": "7A3S",
	"./detail-tm2.svg": "iAo2",
	"./document.svg": "hzSG",
	"./home.svg": "5COo",
	"./pay-alipay.svg": "S7Jq",
	"./pay-bank.svg": "jTNZ",
	"./pay-days.svg": "O19/",
	"./pay-wechat.svg": "Jr3b",
	"./search.svg": "dZHa",
	"./smille.svg": "IL0V",
	"./to-top.svg": "dVoA",
	"./tool.svg": "8b2j",
	"./trademark.svg": "cjIs",
	"./workbench.svg": "1SAd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tJe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = /tJe
// module chunks = 29